import camelCase from 'lodash/camelCase';
export function addAllyTM({ content, id, elementType, withAllyTM, }) {
    if (!withAllyTM) {
        return {};
    }
    const customValue = typeof withAllyTM === 'string' ? withAllyTM : undefined;
    const safeContent = typeof content === 'string' ? content : undefined;
    const returnValue = camelCase(customValue || safeContent || id);
    if (elementType === 'form') {
        return {
            allytmfn: returnValue,
        };
    }
    return {
        allytmln: returnValue,
    };
}
//# sourceMappingURL=addAllyTM.js.map